import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PlanogramLayout } from "src/app/models/layout/planogram-layout";
import { PlanogramProduct } from "src/app/models/layout/planogram-product";
import { PlanogramService } from 'src/app/services/planogram.service';
import { ZoomService } from 'src/app/services/zoom.service';
import { LayoutService } from 'src/app/services/layout.service';
import { PlanogramManualDropComponent } from '../planogram-manual-drop/planogram-manual-drop.component';

@Component({
    selector: 'app-planogram-manual-layout',
    templateUrl: './planogram-manual-layout.component.html',
    styleUrls: ['./planogram-manual-layout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PlanogramManualDropComponent]
})
export class PlanogramManualLayoutComponent {
  layout: PlanogramLayout | null = null;

  productBinProducts: PlanogramProduct[] = [];

  private destroyRef = inject(DestroyRef);

  constructor(
    private planogramService: PlanogramService,
    private layoutService: LayoutService,
    private zoomService: ZoomService,
    private cdr: ChangeDetectorRef)
  {
    this.layoutService.layout$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(layout => {
      this.layout = layout;
      this.cdr.markForCheck();
    });

    this.zoomService.zoom$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.cdr.markForCheck();
    });
  }
  
  getStartingShelfNumber(dropIndex: number): number {
    // Get all previous drops
    const previousDrops = this.layout?.drops.slice(0, dropIndex) ?? [];
    
    // Sum up the number of shelves in all previous drops
    const previousShelvesCount = previousDrops.reduce((sum, drop) => sum + drop.shelves.length, 0);
    
    return previousShelvesCount + 1;
  }

  getDropStyle(dropIndex: number) {
    let style: any = {};
    
    // Get drop settings for potential overrides
    const dropSettings = this.layoutService.getDropSettings(dropIndex);
    
    // Use drop-specific dimensions if available, otherwise use planogram defaults
    let dropHeight: number = dropSettings?.height ?? this.planogramService.getDropHeight();
    let shelfWidth: number = dropSettings?.width ?? this.planogramService.getShelfWidth();
    
    dropHeight *= this.zoomService.getCurrentZoom();
    shelfWidth *= this.zoomService.getCurrentZoom();
    
    style['height'] = `${dropHeight}px`;
    style['width'] = `${shelfWidth}px`;
    return style;
  }
}